<template>
  <!-- eslint-disable max-len -->
  <div>
    <svg style="position: absolute; top: -9999px;">
      <!-- UI ICONS -->
      <symbol
        id="icon_ui_info"
        viewBox="0 0 500 500"
        width="100%"
        height="100%"
      >
        <path
          d="M467,250c0,119.85-97.15,217-217,217S33,369.85,33,250,130.15,33,250,33A217,217,0,0,1,467,250Z M250,182.35c16.62,0,30.38-13.37,30.38-30s-13.76-30-30.38-30a30.53,30.53,0,0,0-21.42,8.76,29.63,29.63,0,0,0-9,21.21C219.62,169,233.38,182.35,250,182.35Z M250,224.25c-16.62,0-30.38,13.44-30.38,28.82V361.65c0,15.39,13.76,27.94,30.38,27.94s30.38-12.56,30.38-27.94V253.07C280.38,237.67,266.62,224.25,250,224.25Z"
        />
      </symbol>
      <symbol
        id="icon_ui_arrow-download"
        viewBox="0 0 500 500"
      >
        <path
          d="M250,353.24,126.39,229.62l25.84-25.82,79.31,79.32v-212h36.91v212l79.32-79.32,25.84,25.82ZM148.53,428.87H351.46V392H148.53Z"
        />
      </symbol>
      <symbol
        id="icon_ui_caret-down"
        viewBox="0 0 500 500"
      >
        <path
          d="M233.39,315.26,117.47,203.34l33.22-34.6L250,264.68l99.31-95.94,33.22,34.6L266.61,315.26l-16.61,16Z"
        />
      </symbol>
      <symbol
        id="icon_ui_caret-left"
        viewBox="0 0 500 500"
      >
        <path
          d="M184.74,233.39,296.66,117.47l34.6,33.22L235.32,250l95.94,99.31-34.6,33.22L184.74,266.61l-16-16.61Z"
        />
      </symbol>
      <symbol
        id="icon_ui_caret-right"
        viewBox="0 0 500 500"
      >
        <path
          d="M315.27,266.61,203.34,382.53l-34.6-33.22L264.68,250l-95.94-99.31,34.6-33.22L315.27,233.39l16,16.61Z"
        />
      </symbol>
      <symbol
        id="icon_ui_caret-up"
        viewBox="0 0 500 500"
      >
        <path
          d="M266.61,184.74,382.53,296.66l-33.22,34.6L250,235.32l-99.31,95.94-33.22-34.6L233.39,184.74l16.61-16Z"
        />
      </symbol>
      <symbol
        id="icon_ui_check"
        viewBox="0 0 500 500"
      >
        <path d="M114.25,260.19l29.26-37.59,78.18,64.48L350.17,146.2l35.58,31.89L226.68,353.8Z" />
      </symbol>
      <symbol
        id="icon_ui_close"
        viewBox="0 0 500 500"
      >
        <path
          d="M368.47,337.78,280.68,250l87.78-87.78a21.7,21.7,0,1,0-30.69-30.69L250,219.31l-87.78-87.78a21.7,21.7,0,0,0-30.69,30.69L219.31,250l-87.78,87.78a21.7,21.7,0,1,0,30.69,30.68L250,280.68l87.78,87.78a21.7,21.7,0,1,0,30.69-30.68Z"
        />
      </symbol>
      <symbol
        id="icon_ui_compare"
        viewBox="0 0 500 500"
      >
        <path
          d="M320.6,354.4h69.59V145.6H285.8V110.81h116A23.19,23.19,0,0,1,425,134V366a23.19,23.19,0,0,1-23.2,23.2h-116V354.4Zm-116-243.59V76H251V424H204.6v-34.8H100.21A23.19,23.19,0,0,1,77,366V134a23.19,23.19,0,0,1,23.2-23.2Z"
        />
      </symbol>
      <symbol
        id="icon_ui_exclamation"
        viewBox="0 0 500 500"
      >
        <path d="M250,76.78A173.22,173.22,0,1,0,423.22,250,173.22,173.22,0,0,0,250,76.78ZM275.21,345.1a11,11,0,0,1-11,11H235.77a11,11,0,0,1-11-11V316.65a11,11,0,0,1,11-11h28.46a11,11,0,0,1,11,11Zm0-70.43a11,11,0,0,1-11,11H235.77a11,11,0,0,1-11-11V154.9a11,11,0,0,1,11-11h28.46a11,11,0,0,1,11,11Z" />
      </symbol>
      <symbol
        id="icon_ui_log-out"
        viewBox="0 0 500 500"
      >
        <path
          d="M170.44,266l57.38,57.09-22.49,22.77L109.51,250l95.82-95.82,22.49,22.77L170.44,234H324.53V266ZM297.32,122.23v31.94h61.23V345.82H297.32v31.95h93.17V122.23Z"
        />
      </symbol>
      <symbol
        id="icon_ui_plus"
        viewBox="0 0 500 500"
      >
        <path
          d="M249.38,112.75c13.55,0,24.62,11.08,24.62,23.39V226h88.63c13.54,0,24.62,11.07,24.62,23.38A24.69,24.69,0,0,1,362.63,274H274v88.63a24.69,24.69,0,0,1-24.62,24.62c-12.31,0-23.38-11.08-23.38-24.62V274H136.14c-12.31,0-23.39-11.07-23.39-24.62,0-12.31,11.08-23.38,23.39-23.38H226V136.14C226,123.83,237.07,112.75,249.38,112.75Z"
        />
      </symbol>
      <symbol
        id="icon_ui_print"
        viewBox="0 0 500 500"
      >
        <path
          d="M424.84,366.42a9.16,9.16,0,0,0-6.53-2.61h-36.4V263.66a9.1,9.1,0,0,0-9.11-9.1H127.07a9.09,9.09,0,0,0-9.1,9.1V363.81H90.66V199.93H409.21V336.5a9.1,9.1,0,1,0,18.2,0V190.83a9.1,9.1,0,0,0-9.1-9.11h-36.4v-41a9.11,9.11,0,0,0-9.11-9.11H318.2V81.58a9.1,9.1,0,0,0-9.1-9.11h-182c-.28,0-.57,0-.85,0A9.12,9.12,0,0,0,118,81.58V181.72H80.71a9.12,9.12,0,0,0-8.25,9.11V372.91a9.1,9.1,0,0,0,9.1,9.11H118v36.42a9.09,9.09,0,0,0,9.1,9.1H372.8a9.1,9.1,0,0,0,9.11-9.1V382h36.4a9.12,9.12,0,0,0,6.53-15.6ZM136.17,90.68H300v50.08a9.1,9.1,0,0,0,9.11,9.1h54.6v31.86H136.17Zm202.2,284.17a9.13,9.13,0,0,1-6.52,2.62H168a9.11,9.11,0,0,1-.85-18.21,6,6,0,0,1,.85,0H331.85a9.08,9.08,0,0,1,6.52,2.61,9.13,9.13,0,0,1,0,13Zm0-54.62a9.08,9.08,0,0,1-6.52,2.61H168a9.11,9.11,0,0,1-.85-18.21,6,6,0,0,1,.85,0H331.85a9.12,9.12,0,0,1,6.52,15.6Z"
        />
      </symbol>
      <symbol
        id="icon_ui_restore"
        viewBox="0 0 500 500"
      >
        <path
          d="M71.58,404.11a6.14,6.14,0,0,1-10.49-4.33V320.24a6.14,6.14,0,0,1,6.14-6.14h79.24a6.14,6.14,0,0,1,4.35,10.47l-27.93,28,3.21,3.48c30.52,33.18,73.61,52.47,118,52.47a158.56,158.56,0,0,0,0-317.12,156.2,156.2,0,0,0-108.19,43.62l-2.46,2.37-25.74-26.77,2.47-2.36c36.42-34.78,83.81-54,133.92-54,107.7,0,194.8,87.48,194.8,195.72S351.8,445.72,244.11,445.72A193.3,193.3,0,0,1,101,382.47l-3.74-4.12Z"
        />
      </symbol>
      <symbol
        id="icon_ui_view"
        viewBox="0 0 500 500"
      >
        <path d="M250,216.72c23.81,0,43.13,19.07,43.13,42.57S273.81,301.86,250,301.86s-43.13-19.07-43.13-42.57S226.19,216.72,250,216.72Zm0-28.38a72.26,72.26,0,0,0-50.82,20.79,70.24,70.24,0,0,0,0,100.32,72.52,72.52,0,0,0,101.65,0,70.26,70.26,0,0,0,0-100.32A72.3,72.3,0,0,0,250,188.34Zm0-55.48a238.67,238.67,0,0,1,167.5,68.4l15.67,15.46a60.73,60.73,0,0,1,0,86.56L417.5,318.74a239.29,239.29,0,0,1-335,0L66.83,303.28a60.73,60.73,0,0,1,0-86.56L82.5,201.26A238.65,238.65,0,0,1,250,132.86Z" />
      </symbol>
      <symbol
        id="icon_ui_hide"
        viewBox="0 0  500 500"
      >
        <path d="M250.15,191.1a67.27,67.27,0,0,0-67.37,67.38,78.28,78.28,0,0,0,2.11,17.79L268,193.65A64.36,64.36,0,0,0,250.15,191.1ZM379,180.94a288.32,288.32,0,0,1,61.88,50.42,40.87,40.87,0,0,1,0,54.68c-31.78,33.9-96.19,86.88-190.7,86.88a236,236,0,0,1-56.37-6.79l41.53-41.53a60.09,60.09,0,0,0,14.84,1.68c37.29,0,67.37-30.51,67.37-67.8a55.4,55.4,0,0,0-1.69-14.4Zm-5.93-92.82a21.57,21.57,0,0,1,30.51,30.5L110.32,411.88a21.58,21.58,0,0,1-30.53-30.51l43.66-43.65a284.91,284.91,0,0,1-64-51.7,40,40,0,0,1,0-54.66c31.78-33.9,96.19-86.88,190.7-86.88a239.62,239.62,0,0,1,59.33,7.2Z" />
      </symbol>

      <!-- OTHER ICONS -->

      <symbol
        id="icon_question-mark-in-circle"
        viewBox="0 0 500 500"
      >
        <path
          d="M266.54,140.05a77.8,77.8,0,0,0-94.26,76,17.18,17.18,0,1,0,34.35,0,43.39,43.39,0,1,1,58,40.85,47.85,47.85,0,0,0-31.8,44.93v5a17.19,17.19,0,0,0,34.38,0v-5.24a13.13,13.13,0,0,1,9-12.36c36.95-13.21,57.92-51,49.83-89.74-6.12-29.43-30-53.33-59.47-59.47M250,337.13a15.14,15.14,0,1,0,15.16,15.12A15.11,15.11,0,0,0,250,337.13M250,9.46C117.16,9.46,9.46,117.15,9.46,250S117.15,490.54,250,490.54,490.54,382.85,490.54,250,382.85,9.46,250,9.46m0,446.72C136.31,456.18,43.82,363.69,43.82,250S136.31,43.82,250,43.82,456.18,136.31,456.18,250,363.69,456.18,250,456.18"
        />
      </symbol>

    </svg>
  </div>
  <!-- eslint-enable max-len -->
</template>

<script>
export default {
  name: 'SvgSymbols'
};
</script>

<style lang="scss" scoped>

</style>
